import { jsx } from "panel";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { Directions } from "common/components/drop-menu/types";
import { StickyPlaceholderEl } from "common/widgets/sticky-placeholder";
import { InsightsFormulaEditorEl } from "./insights-formula-editor/index";
import { InsightsFormulaClauseEl } from "./insights-formula-clause/index";
export function template() {
  const { formulas, isNewPaneOpen } = this.state;
  const formulaDisabledReasonMessage = this.attr(`disabled-reason`);
  const isFormulaEnabled = !formulaDisabledReasonMessage;
  return /* @__PURE__ */ jsx("div", {
    sel: ".insights-formula-container",
    class: { "is-empty": formulas.length === 0 }
  }, /* @__PURE__ */ jsx(StickyPlaceholderEl, {
    props: {
      stickyElm: this.helpers.getStickyHeaderElm()
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-entry-section-header",
    class: {
      "is-sticky": true
    },
    hook: {
      insert: (node) => this.helpers.onInsertStickyHeader(node.elm)
    }
  }, /* @__PURE__ */ jsx(SelectEl, {
    sel: ".add-formula-button",
    attrs: {
      "always-show-caret": true,
      elref: `addFormulaButton`,
      disabled: !isFormulaEnabled,
      icon: { leftIcon: ``, rightIcon: `plus` },
      label: `Formulas`,
      "menu-alignment": Directions.Right,
      tooltip: this.helpers.getTooltipAttrs(),
      theme: SelectTheme.Tertiary,
      "experimental-positioning": true
    },
    class: {
      open: isNewPaneOpen
    },
    on: {
      menuChange: (ev) => this.helpers.handleMenuChange(ev)
    },
    props: {
      dropdownBodyRenderer: () => /* @__PURE__ */ jsx(InsightsFormulaEditorEl, {
        on: {
          save: this.helpers.handleSaveNew
        }
      })
    }
  })), formulas.map((formula, formulaIdx) => {
    var _a, _b, _c;
    return /* @__PURE__ */ jsx("div", {
      sel: ".formula-clause.formula-control"
    }, /* @__PURE__ */ jsx(InsightsFormulaClauseEl, {
      props: { formula },
      attrs: {
        elref: formulaIdx,
        theme: this.helpers.buttonTheme(),
        error: ((_c = (_b = (_a = this.error) == null ? void 0 : _a.formula_errors) == null ? void 0 : _b[formulaIdx]) == null ? void 0 : _c.message) || ``
      },
      on: {
        update: (ev) => this.helpers.handleUpdate(ev, formulaIdx),
        delete: () => this.helpers.handleDelete(formulaIdx)
      }
    }));
  }));
}
